import { render, staticRenderFns } from "./TermsOfServiceCheckboxField.vue?vue&type=template&id=05744744&"
import script from "./TermsOfServiceCheckboxField.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceCheckboxField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports